import React, { useEffect, useState, useMemo } from 'react';
import HappyKid from '../img/sa-enkelt-bg.jpg';
import { getVisibleAssociationsWithTeamsQuery } from '../queries/queries';
import { useQuery } from '@apollo/client';
import { useAutosize } from '../common';
import { useNavigationContext } from '../context/NavigationContext';
import WebshopNavigation from './webshop/WebshopNavigation';
import StartPageMobiles from '../img/startpage-mobiles.png';
import Order from './webshop/Order';
import AssociationList from './AssociationList';

const { REACT_APP_BRAND } = process.env;

function Startpage() {
  const { height } = useAutosize();
  const { setNavigationActivated } = useNavigationContext();
  const [isAssociationOrderView, setIsAssociationOrderView] = useState(false);

  // Fetch visible associations with teams and team members from backend
  const domain = window.location.hostname;
  const { data, loading } = useQuery(getVisibleAssociationsWithTeamsQuery, {
    variables: { domain },
    fetchPolicy: 'cache-and-network'
  });

  const filteredAssociations = useMemo(() => data?.visibleAssociationsWithTeams || [], [data]);

  // Initial background color and navigation setup
  useEffect(() => {
    setNavigationActivated(false);

    // Set background color, fix for mobile styling issue
    document.querySelector('.App').style.backgroundColor = '#82C8C8';

    return () => {
      document.querySelector('.App').style.backgroundColor = '#EEF8F6';
    }
  }, [setNavigationActivated]);

  /**
   * Change view - If there is only one association and no active teams, show the order view
   * This is not a redirect, but a view change
   */
  useEffect(() => {
    if (!loading && filteredAssociations?.length === 1 && filteredAssociations[0]?.teams?.length === 0) {
      setIsAssociationOrderView(true);
    }
  }, [filteredAssociations, loading]);

  // Loading - Show nothing while loading
  if (loading) {
    return null;
  }

  // Render - Association order view
  if (isAssociationOrderView) {
    return <Order
      match={{
        params: {
          association: filteredAssociations[0].slug,
          team: null,
          teammember: null
        }
      }}
      hideChangeShop={true}
    />;
  }

  // Render - Startpage view
  return (
    <div id="se-webshop" style={{ minHeight: height }} className={REACT_APP_BRAND === 'SAENKELT' ? 'saenkelt' : ''}>
      <WebshopNavigation />
      <div className="container relative" style={{ minHeight: height - 65 }}>
        {REACT_APP_BRAND === 'SAENKELT' && <img className='bg-img' src={HappyKid} alt="" style={{ minHeight: height - 65 }} />}
        <div className="content relative">
          <div className="content-header">
            <h1>Köp ett häfte</h1>
            {REACT_APP_BRAND === 'SAENKELT'
              ? <p>Köp ett rabatthäfte och stötta föreningslivet!</p>
              : <p>Köp ett rabatthäfte och stötta det lokala näringslivet!</p>
            }
            <div className="img-container">
              <img src={StartPageMobiles} alt="webshop" />
            </div>
          </div>
          <div className="association-list-container">
            <span className="support">Jag vill köpa av</span>
            <AssociationList
              associations={filteredAssociations}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Startpage;
